import { makeAutoObservable } from 'mobx'
import { SelectType } from './models'

class Directory {
	facultyList: SelectType[] = []
	yearList: SelectType[] = []
	// yearList: SelectType[] = [{
	//     value: 14,
	//     label: "2014-15"
	// },
	// {
	//     value: 15,
	//     label: "2015-16"
	// },
	// {
	//     value: 16,
	//     label: "2016-17"
	// },
	// {
	//     value: 17,
	//     label: "2017-18"
	// },
	// {
	//     value: 18,
	//     label: "2018-19"
	// },
	// {
	//     value: 19,
	//     label: "2019-20"
	// },
	// {
	//     value: 20,
	//     label: "2020-21"
	// },
	// {
	//     value: 21,
	//     label: "2021-22"
	// },
	// {
	//     value: 22,
	//     label: "2022-23"
	// },
	// {
	//     value: 23,
	//     label: "2023-24"
	// }]
	fEducList: SelectType[] = []
	rateList: SelectType[] = []
	groupList: SelectType[] = []
	constructor() {
		makeAutoObservable(this)
	}

	async getFacultyList(param: SelectType[]) {
		this.facultyList = param
	}
	async getYearList(param: SelectType[]) {
		this.yearList = param
	}
	async getFEducList(param: SelectType[]) {
		this.fEducList = param
	}
	async getRateList(param: SelectType[]) {
		this.rateList = param
	}
	async getGroupList(param: SelectType[]) {
		this.groupList = param
	}
}

export const directory = new Directory()
